import React from 'react';
import { PieChart, Pie, ResponsiveContainer } from 'recharts';

import styles from './BudgetSummary.module.css';
import { formatCents } from '../../utils';
import RDSHeading from '../../components/RDSHeading';

type BudgetSummaryProps = {
  totalAmount: number;
  data: {
    name: string;
    value: number;
    fill: string;
  }[];
};

const DEFAULT_CHART_DATA = {
  name: 'Default',
  value: 100,
  fill: '#D5D9DB',
};

const BudgetSummary = (props: BudgetSummaryProps) => {
  const { totalAmount = 0, data } = props;
  const expenseData = totalAmount > 0 ? data : [DEFAULT_CHART_DATA];

  return (
    <div className={styles.BudgetSummary}>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            dataKey="value"
            data={expenseData}
            innerRadius={100}
            outerRadius="100%"
            stroke=""
          />
        </PieChart>
      </ResponsiveContainer>
      <div className={styles.TextContainer}>
        <RDSHeading level="3" size="xsmall" className={styles.Label}>
          Total Expenses
        </RDSHeading>
        <span className={styles.Total}>
          {formatCents(totalAmount, { currency: '$' })}
        </span>
      </div>
    </div>
  );
};

export default BudgetSummary;
